export enum WorkOrderStatus {
  Accepted = 'Accepted',
  Archived = 'Archived',
  Blocked = 'Blocked',
  Completed = 'Completed',
  InProgress = 'In Progress',
  Opened = 'Opened',
}
